import React from 'react';
import styled from 'styled-components';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { AlertCircleOutlineImg } from './Common.styled';

const AlertText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : '#ED002A')};
    opacity: 1;
    padding: ${(props) => props.padding};
`;

const AlertMsg = ({ message, height, width, margin }) => {
    return (
        <>
            <AlertCircleOutlineImg
                src={AlertCircleOutline}
                height={height}
                width={width}
                margin={margin}
            />
            <AlertText>{message}</AlertText>
        </>
    );
};

export default AlertMsg;
